import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import CollapsibleDisclosure from './CollapsibleDisclosure';

import './CollapsibleTitle.scss';

function CollapsibleTitle ({
	children, collapsibleContentId, collapsibleDisclosureId, open, setOpen, disclosureIconVariant = 'caret'
}) {

	const isCaret = disclosureIconVariant === 'caret';
	const isPlus = disclosureIconVariant === 'plus';
	
	const iconClassName = classNames(
		{
			'CollapsibleTitle__icon--caret': isCaret,
			'CollapsibleTitle__icon--plus': isPlus,
			'CollapsibleTitle__icon--open': open,
			'CollapsibleTitle__icon--closed': !open,
		}
	)

	return (
		<CollapsibleDisclosure
			open={open}
			setOpen={setOpen}
			collapsibleContentId={collapsibleContentId}
			collapsibleDisclosureId={collapsibleDisclosureId}
		>
			<div className="CollapsibleTitle">
				{children}
				<div className={iconClassName} />
			</div>
		</CollapsibleDisclosure>
	);

}

CollapsibleTitle.propTypes = {
	children: PropTypes.oneOfType([ PropTypes.node, PropTypes.arrayOf(PropTypes.node) ]).isRequired,
	collapsibleContentId: PropTypes.string.isRequired,
	collapsibleDisclosureId: PropTypes.string.isRequired,
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired,
	disclosureIconVariant: PropTypes.string
};

export default CollapsibleTitle;
